// extracted by mini-css-extract-plugin
export default {"container":"currentChatUserData_container__-vjh-"};